import { Outlet } from 'react-router-dom';
import styles from './style.module.css';
import logo from '../../assets/images/logo.png'
import MenuComponent from './menu';
import HeaderComponent from './header';

export default function Layout() {

  return (
    <div className={'d-flex'}>
      <div className='flex-fill' style={{ maxWidth: 280 }}>
        <div className='col-8 mx-auto mt-2 mb-4'>
          <a href="/">
            <img className='w-100' src={logo} alt="logo" />
          </a>
        </div>
        <MenuComponent />
      </div>
      <div className='flex-fill position-relative' style={{ backgroundColor: 'aliceblue', maxWidth: 'calc(100% - 280px)' }}>
        <HeaderComponent />
        <div className={`p-3 ${styles.main}`}>
          <Outlet />
        </div>
      </div>
    </div>
  )
}